/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { addMinutes, format } from "date-fns";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
// Dashboard components

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";
import * as Yup from "yup";
// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";

import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  createDynamicColumn,
  createTransaction,
  editTransaction,
  getDynamicColumn,
  getSubModulesByRoleId,
  getTransactions,
  getTransactionsDownload,
} from "../../../store";

// React-Select component and styling

import "../../../index.css";

// config file

import Config from "../../../config/index";
// Cookies
import { Backdrop, CircularProgress, Icon } from "@mui/material";
import MDInput from "components/MDInput";
import EditButton from "components/standardized-components/EditButton";
import { useFormik } from "formik";
import { CSVLink } from "react-csv";
import Cookies from "universal-cookie";
import TextError from "utils/TextError";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const styleForCreatePicklist = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Transaction = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  createTransaction,
  getTransactions,
  getTransactionsReducer,
  getTransactionsDownloadReducer,
  getTransactionsDownload,
  editTransaction,
  getDynamicColumn,
  getDynamicColumnReducer,
  createDynamicColumn,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let jwtToken = loginDetails?.jwt;

  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  const subModuleId = "4423f4d8-d918-497d-9322-480e21960398";

  let transactionModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "4423f4d8-d918-497d-9322-480e21960398",
  );
  let createAccess = transactionModule
    ? transactionModule.actionId.includes(
        "06caa04a-2026-4a83-8875-e6de1cc58703",
      )
    : null;
  let viewAccess = transactionModule
    ? transactionModule.actionId.includes(
        "4f20d4e7-4d64-443e-9acc-70c0b49ddf93",
      )
    : null;
  let editLocation = transactionModule
    ? transactionModule.actionId.includes(
        "bd77bfe0-78b0-4d74-b265-8b517ab566a1",
      )
    : null;
  let downloadAccess = transactionModule
    ? transactionModule.actionId.includes(
        "7982f348-e8a2-4e71-b318-e08aa5011b49",
      )
    : null;

  const [buttonName, setButtonName] = useState("Submit");

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  useEffect(() => {
    viewAccess && getTransactions(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewAccess, pageNo, rowsPerPage, searchObject, refresh]);
  useEffect(() => {
    viewAccess &&
      getTransactionsDownload(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewAccess, pageNo, rowsPerPage, searchObject, refresh]);

  const [state, setState] = useState({
    // columns: [
    //   { Header: "Transaction code", accessor: "transactionCode" },
    //   { Header: "Item Code", accessor: "itemCode" },
    //   { Header: "Item Description", accessor: "itemDescription" },
    //   { Header: "Request Qty", accessor: "requestQty" },
    //   { Header: "Store Qty", accessor: "storeQty" },
    //   { Header: "SF Qty", accessor: "balanceQty" },
    //   { Header: "station", accessor: "station" },
    //   { Header: "To be Picked Qty ", accessor: "pickedQty" },
    //    {

    columns: [
      { Header: "Transaction code", accessor: "transactionCode" },
      { Header: "Item Code", accessor: "itemCode" },

      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },

      { Header: "Request Qty", accessor: "requestQty" },
      { Header: "Store Qty", accessor: "storeQty" },
      { Header: "SF Qty", accessor: "sfQty" },
      { Header: "station", accessor: "station" },
      { Header: "To be Picked Qty ", accessor: "toBePickedQty" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "Action",
        accessor: "edit",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [isErrorMsgForCreate, setIsErrorMsgForCreate] = useState(false);
  const [isErrorForPicklist, setIsErrorPicklist] = useState(false);
  const [isSuccessForPicklist, setIsSuccessPicklist] = useState(false);

  useEffect(() => {
    if (isErrorForPicklist) {
      setTimeout(() => {
        setIsErrorPicklist(false);
      }, 3000);
    }
  }, [isErrorForPicklist]);

  useEffect(() => {
    if (isSuccessForPicklist) {
      setTimeout(() => {
        setIsSuccessPicklist(false);
      }, 3000);
    }
  }, [isSuccessForPicklist]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempAsset = [];
    let data = getTransactionsReducer.transactions.data
      ? getTransactionsReducer.transactions.data
      : [];

    setPaginationObj(getTransactionsReducer?.transactions?.pagination);
    setLoading(getTransactionsReducer.loading);
    data.map((purchase) => {
      const formatDate = new Date(purchase.cd);
      let len = desLength;
      let des = purchase?.itemDescription;
      const purchaseObject = {
        privateKey: purchase.transactionId,
        transactionCode: purchase.transactionCode,
        storeQty: `${purchase.storeQty}`,
        sfQty: `${purchase.sfQty}`,
        balanceQty: `${purchase.balanceQty}`,
        itemCode: purchase.itemCode ? `${purchase.itemCode}` : "",

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {purchase?.itemDescription?.length > 35 ? (
              <Tooltip
                title={purchase.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {purchase.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {purchase.itemDescription}
              </MDTypography>
            )}
            {purchase?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        requestQty: `${purchase.requestQty}`,
        transactionId: purchase.transactionId,
        pckedQty: `${purchase.toBePickedQty}`,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        createdDate2: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: purchase.cd,
        itemId: purchase.itemId,
        station: purchase.station,
        stationId: purchase.stationId,
        toBePickedQty: purchase.toBePickedQty,
        // isEditable: purchase.isEditable,

        edit: (
          <span style={{ display: "flex" }}>
            <Tooltip title="Edit">
              {editLocation && (
                <EditButton
                  tooltip="Edit"
                  style={{ marginRight: "5px", borderRadius: "5px" }}
                  size="small"
                  variant="gradient"
                  color="success"
                  iconOnly
                  type="button"
                  onClick={() => handleOpenUpdateWarehouseModal(purchase)}
                >
                  <Icon>edit_sharp</Icon>
                </EditButton>
              )}
            </Tooltip>
          </span>
        ),
      };
      tempAsset.push(purchaseObject);
    });

    setState({ ...state, rows: tempAsset });
  }, [getTransactionsReducer]);

  const [Download, setDownload] = useState("");

  useEffect(() => {
    let tempAsset = [];
    let data = getTransactionsDownloadReducer.transactions.data
      ? getTransactionsDownloadReducer.transactions.data
      : [];

    // setPaginationObj(getTransactionsDownloadReducer?.transactions?.pagination);
    // setLoading(getTransactionsDownloadReducer.loading);
    data.map((purchase) => {
      const formatDate = new Date(purchase.cd);
      let len = desLength;
      let des = purchase?.itemDescription;
      const purchaseObject = {
        privateKey: purchase.transactionId,
        transactionCode: purchase.transactionCode,
        storeQty: `${purchase.storeQty}`,
        sfQty: `${purchase.sfQty}`,
        balanceQty: `${purchase.balanceQty}`,
        itemCode: purchase.itemCode ? `${purchase.itemCode}` : "",
        itemDescription: `${des ? des.substring(0, len) : ""}`,
        requestQty: `${purchase.requestQty}`,
        transactionId: purchase.transactionId,
        pckedQty: `${purchase.toBePickedQty}`,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        createdDate2: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),

        cd: purchase.cd,
        itemId: purchase.itemId,
        station: purchase.station,
        stationId: purchase.stationId,
        toBePickedQty: purchase.toBePickedQty,
        // isEditable: purchase.isEditable,
        edit: (
          <EditButton
            tooltip="Edit"
            // disabled={!editLocation}
            variant="gradient"
            color="success"
            iconOnly
            type="button"
            onClick={() => handleOpenUpdateWarehouseModal(purchase)}
            style={{ marginRight: "5px" }}
          >
            <Icon>edit_sharp</Icon>
          </EditButton>
        ),
      };
      tempAsset.push(purchaseObject);
    });

    setDownload(tempAsset);
  }, [getTransactionsDownloadReducer]);
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const [openCreatePicklistModal, setOpenCreatePicklistModal] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  const handleOpenCreatePicklistModal = (data = {}) => {
    setOpenCreatePicklistModal(true);
  };

  const handleCloseCreatePicklistModal = () => {
    setOpenCreatePicklistModal(false);
  };

  const createPicklistHandler = (event, data) => {
    handleOpenCreatePicklistModal(data);
  };

  const [singleWarehouseDataForUpdate, setWarehouseDataForUpdate] = useState(
    {},
  );
  const onSubmitForUpdate = async (values) => {
    setButtonName("Please wait...");
    let payload = {
      transactionId: String(singleWarehouseDataForUpdate.transactionId), // convert to string
      qty: values.pickedQty,
      userId: userId,
    };

    let res = await editTransaction(payload, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      getTransactions(pageNo, rowsPerPage, searchObject, jwtToken);
      // getWarehouseByType(1, pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        setButtonName("Submit");
        handleCloseUpdateWarehouseModal();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setButtonName("Submit");
    }
  };

  const [openUpdateWarehouseModal, setOpenUpdateWarehouseModal] =
    useState(false);

  const handleOpenUpdateWarehouseModal = (Warehouse = {}) => {
    setWarehouseDataForUpdate(Warehouse);
    setOpenUpdateWarehouseModal(true);
    // setIsErrorForUpdate(false);
    // setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateWarehouseModal = () => {
    setOpenUpdateWarehouseModal(false);
    formikForUpdate.setErrors({});
    formikForUpdate.setValues(initialValueForUpdate);
  };

  const initialValueForUpdate = {
    // warehouseId: singleWarehouseDataForUpdate.warehouseId,
    pickedQty: singleWarehouseDataForUpdate.toBePickedQty,
  };

  const [uncheck, setUncheck] = useState(false);

  const [selectedCreatePicklistData, setSelectedCreatePicklistData] = useState(
    [],
  );

  const [disableButton, setDisableButton] = useState(false);
  useEffect(() => {
    let value = selectedCreatePicklistData.some((data) => {
      const storeQty = parseFloat(data.storeQty);
      // const requestedQty = parseFloat(data.requestQty);

      return storeQty === 0;
    });

    setDisableButton(value);
  }, [selectedCreatePicklistData]);

  const [picklistName, setPicklistName] = useState("Create");

  const createPicklistForData = (data) => {
    setSelectedCreatePicklistData(data);
  };
  const onClickCreateReleaseList = async () => {
    setPicklistName("Please wait...");
    let tempArray = [];
    selectedCreatePicklistData.map((data) => {
      const tempPayload = {
        itemId: data.itemId,
        balanceQty: data.balanceQty,
        qty: data.requestQty,
        transactionId: data.transactionId,
        stationId: data.stationId,
      };
      tempArray.push(tempPayload);
    });

    let payload = {
      mvtId: 9,
      items: tempArray,
    };
    let res = await createTransaction(payload, jwtToken);
    if (res.status) {
      setUncheck(!uncheck);
      setIsSuccessPicklist(true);
      getTransactions(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        handleCloseCreatePicklistModal();
        setPicklistName("Create");
      }, 2250);
    }
    if (!res.status) {
      setIsErrorPicklist(true);
      setIsErrorMsgForCreate(res?.data?.data?.msg);
      setPicklistName("Create");
    }
  };
  const validationSchemaForUpdate = Yup.object({
    pickedQty: Yup.number().positive("Value cannot be negative"), // Ensures the field is not empty
  });

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  const headers = [
    {
      label: "transactionCode",
      key: "transactionCode",
    },
    {
      label: "itemCode",
      key: "itemCode",
    },
    { label: "itemDescription", key: "itemDescription" },
    { label: "requestQty", key: "requestQty" },
    { label: "storeQty", key: "storeQty" },
    { label: "sfQty", key: "sfQty" },
    { label: "station", key: "station" },
    { label: "To be picked qty", key: "toBePickedQty" },
    {
      label: "createdDate",
      key: "createdDate2",
    },
  ];

  const csvLink = {
    filename: "Transaction List.csv",
    headers: headers,
    data: Download,
  };

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getTransactions(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };
  return (
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox color="text" px={2} ml={-2} mb={3}>
                {downloadAccess ? (
                  <CSVLink {...csvLink}>
                    <Tooltip title="Download Transaction List">
                      <MDButton
                        style={{ marginRight: "1rem", borderRadius: "5px" }}
                        size="small"
                        type="button"
                        variant="outlined"
                        color="success"
                        iconOnly
                      >
                        <Icon>download</Icon>
                      </MDButton>
                    </Tooltip>
                  </CSVLink>
                ) : (
                  ""
                )}
              </MDBox>
            </MDBox>

            <MDBox pt={0}>
              {loadingForDynamicColumn && (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  options={{ draggable: false }}
                  serverSidePagination={true}
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  selection={true}
                  uncheckProp={uncheck}
                  selectionButtonClick={createPicklistForData}
                  selectionButtonComponent={
                    <Tooltip>
                      {createAccess && (
                        <MDButton
                          color="white"
                          type="button"
                          disabled={disableButton}
                          style={{
                            marginTop: "0.5rem",
                            color: "white",
                            border: "1px solid #0275d8",
                            background: "#0275d8",
                            marginLeft: "1rem",
                            marginBottom: "0.8rem",
                          }}
                          onClick={(evt, data) =>
                            createPicklistHandler(evt, data)
                          }
                        >
                          Create Picklist
                        </MDButton>
                      )}
                      {disableButton && (
                        <MDTypography
                          color="error"
                          variant="p"
                          style={{
                            // textAlign: "center",
                            marginLeft: "1rem",
                            marginTop: "1rem",
                          }}
                        >
                          Store Quantity is Zero you cannot create Picklist!
                        </MDTypography>
                      )}
                    </Tooltip>
                  }
                  loading={loading}
                  hideColumns={hiddenColumsDetails}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                />
              )}
            </MDBox>

            <Modal
              open={openUpdateWarehouseModal}
              onClose={handleCloseUpdateWarehouseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseUpdateWarehouseModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox mb={2}>
                      <MDTypography variant="h6">Picked Qty</MDTypography>
                      <MDInput
                        type="text"
                        name="pickedQty"
                        fullWidth
                        autoComplete="off"
                        onBlur={formikForUpdate.handleBlur}
                        onChange={formikForUpdate.handleChange}
                        value={formikForUpdate.values.pickedQty}
                        error={
                          formikForUpdate.touched.pickedQty &&
                          formikForUpdate.errors.pickedQty &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formikForUpdate.touched.pickedQty &&
                        formikForUpdate.errors.pickedQty && (
                          <TextError msg={formikForUpdate.errors.pickedQty} />
                        )}
                    </MDBox>

                    <MDBox>
                      <Collapse in={isErrorForUpdate}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForUpdate(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsgForUpdate}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessForUpdate}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForUpdate(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Updated successfully
                        </Alert>
                      </Collapse>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDButton
                        variant="contained"
                        color="success"
                        fullWidth
                        type="submit"
                        disabled={
                          !formikForUpdate.isValid ||
                          buttonName === "Please wait..."
                        }
                      >
                        {buttonName}
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>

            <Modal
              open={openCreatePicklistModal}
              onClose={handleCloseCreatePicklistModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForCreatePicklist}>
                <MDTypography>
                  Are you sure you want to Create Picklist?
                </MDTypography>
                <MDBox mt={2} ml={3}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreatePicklistModal}
                  >
                    Cancel
                  </MDButton>

                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="info"
                    onClick={onClickCreateReleaseList}
                    disabled={picklistName === "Please wait..."}
                  >
                    {picklistName}
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessForPicklist}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessPicklist(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Created successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorForPicklist}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorPicklist(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForCreate}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getTransactionsReducer: state.getTransactionsReducer,
    getTransactionsDownloadReducer: state.getTransactionsDownloadReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getTransactions: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getTransactions(pageNo, rowsPerPage, searchObject, jwtToken)),
    getTransactionsDownload: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getTransactionsDownload(pageNo, rowsPerPage, searchObject, jwtToken),
      ),
    createTransaction: (payload, jwtToken) =>
      dispatch(createTransaction(payload, jwtToken)),
    editTransaction: (payload, jwtToken) =>
      dispatch(editTransaction(payload, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Transaction);
